import { ConfigOption } from '@ngx-formly/core';
import { FormlyCountryCodeDropdownComponent } from './formly-country-code-dropdown/formly-country-code-dropdown.component';
import { FormlyProvisionGroupListComponent } from './formly-provision-group-list/formly-provision-group-list.component';
import { ProvisionGroupDropdownComponent } from './provision-group-dropdown/provision-group-dropdown.component';

export const CONSTANTS_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-provision-group-list', component: FormlyProvisionGroupListComponent },
  { name: 'formly-provision-group-dropdown', component: ProvisionGroupDropdownComponent, wrappers: ['simple-title'] },
  { name: 'formly-country-code-dropdown', component: FormlyCountryCodeDropdownComponent, wrappers: ['simple-title'] },
]
